
          export const options = {
  "includeNodeModules": false,
  "options": {},
  "clients": {
    "default": {
      "endpoint": "https://benchmark-www-staging.stellate.sh",
      "options": {
        "requireCredentials": false
      }
    },
    "authenticatedClient": {
      "endpoint": "https://wp-staging.benchmarkminerals.com/wp/graphql",
      "options": {
        "requireCredentials": true
      }
    }
  }
}
        